import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import * as UserUploadConstants from "../constants/UserUploadConstants";

dayjs.extend(utc);

export const isFinalStatus = (status) =>
  UserUploadConstants.USER_UPLOAD_FINAL_STATUSES.includes(status);

export const statusLabelId = (status) =>
  UserUploadConstants.USER_UPLOAD_STATUS_LABELS[status] ||
  "user_upload_status_queued";

export const statusSeverity = (status) =>
  UserUploadConstants.USER_UPLOAD_STATUS_SEVERITIES[status] || "info";

export const rowResultLabelId = (result) =>
  UserUploadConstants.USER_UPLOAD_ROW_RESULT_LABELS[result] ||
  "user_upload_result_failed";

export const errorMessageId = (code) =>
  UserUploadConstants.USER_UPLOAD_ERROR_MESSAGES[code] ||
  "something_else_wrong";

// The API sends UTC times, sometimes without an offset; show them in local time
// in the same format as ListCellRenders.DateTime.
export const formatUploadTime = (value) =>
  value ? dayjs.utc(value).local().format("DD MMM YYYY hh:mm a") : "-";

// "staff.xlsx" -> "staff-results.xlsx"
export const resultsFileName = (fileName) =>
  `${(fileName || "upload.xlsx").replace(/\.xlsx$/i, "")}-results.xlsx`;
